/* eslint-disable react-hooks/exhaustive-deps */
import "react-calendar/dist/Calendar.css";
import "../pages/Attendance.css";
import { useEffect, useState } from "react";
import { hitApi } from "../utils/apiCall";
import { Card } from "react-bootstrap";
import blackboard from "./assets/blackboard.png";
import { getTrueKeys } from "../utils/ObjKeyInArray";

const SelectClassStudents = ({ setClassfromComp }) => {
  const [selectedClass, setSelectedClass] = useState({});
  const [fetchedClassList, setFetchedClassList] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [theme] = useState(localStorage.getItem("theme"));

  // Handle changes when a checkbox is clicked
  const handleChange = (value) => {
    setSelectedClass((prev) => {
      const newState = { ...prev, [value]: !prev[value] };
      localStorage.removeItem("section-students");
      return newState;
    });
  };

  // Load the selected branches from localStorage and set them in state
  useEffect(() => {
    const storedClass = JSON.parse(localStorage.getItem("class-students"));
    if (storedClass) {
      setSelectedClass(storedClass);
    }
  }, []);

  // Save selected branches to localStorage whenever selectedClass changes
  useEffect(() => {
    if (Object.keys(selectedClass).length > 0) {
      localStorage.setItem("class-students", JSON.stringify(selectedClass));
    }
    setClassfromComp(selectedClass);
  }, [selectedClass]);

  // Fetch the branch list from API
  useEffect(() => {
    async function getClassList() {
      const fd = new FormData();
      getTrueKeys(JSON.parse(localStorage.getItem("branch-students"))).forEach(
        (ele) => fd.append("branch[]", ele)
      );
      setIsLoading(true);
      // const res = await hitApi('teacher/teacherCurl', 'getClassDetails', fd);
      const res = await hitApi(
        "multiple/getMultipleDetails",
        "getMultipleClassDetailsOnChangeOfBranch",
        fd
      );
      console.log(res);

      if (res.success) {
        setFetchedClassList(res.data);
        setIsLoading(false);
      } else {
        setFetchedClassList(res.data);
        setIsLoading(false);
      }
    }
    getClassList();
  }, []);

  return (
    <div
      style={{ maxHeight: "73vh", overflow: "hidden", overflowY: "auto" }}
      className="p-1 pb-5"
    >
      {isLoading ? (
        <div className="row">
          {/* {Array.from({ length: 20 }).map((_, index) => (
                            <
                            div className="card mb-2 col-6" aria-hidden="true">
                                <div className="card-body">
                                    <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
                                        <span className="placeholder col-2 rounded-2"></span>
                                        <span className="placeholder col-8 rounded-2"></span>
                                    </h5>
                                </div>
                            </>
                        ))} */}
          <div className="card mb-2 col-6" aria-hidden="true">
            <div className="card-body">
              <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
                <span className="placeholder col-2 rounded-2"></span>
                <span className="placeholder col-8 rounded-2"></span>
              </h5>
            </div>
          </div>
          <div className="card mb-2 col-6" aria-hidden="true">
            <div className="card-body">
              <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
                <span className="placeholder col-2 rounded-2"></span>
                <span className="placeholder col-8 rounded-2"></span>
              </h5>
            </div>
          </div>
          <div className="card mb-2 col-6" aria-hidden="true">
            <div className="card-body">
              <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
                <span className="placeholder col-2 rounded-2"></span>
                <span className="placeholder col-8 rounded-2"></span>
              </h5>
            </div>
          </div>
          <div className="card mb-2 col-6" aria-hidden="true">
            <div className="card-body">
              <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
                <span className="placeholder col-2 rounded-2"></span>
                <span className="placeholder col-8 rounded-2"></span>
              </h5>
            </div>
          </div>
          <div className="card mb-2 col-6" aria-hidden="true">
            <div className="card-body">
              <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
                <span className="placeholder col-2 rounded-2"></span>
                <span className="placeholder col-8 rounded-2"></span>
              </h5>
            </div>
          </div>
          <div className="card mb-2 col-6" aria-hidden="true">
            <div className="card-body">
              <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
                <span className="placeholder col-2 rounded-2"></span>
                <span className="placeholder col-8 rounded-2"></span>
              </h5>
            </div>
          </div>
          <div className="card mb-2 col-6" aria-hidden="true">
            <div className="card-body">
              <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
                <span className="placeholder col-2 rounded-2"></span>
                <span className="placeholder col-8 rounded-2"></span>
              </h5>
            </div>
          </div>
          <div className="card mb-2 col-6" aria-hidden="true">
            <div className="card-body">
              <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
                <span className="placeholder col-2 rounded-2"></span>
                <span className="placeholder col-8 rounded-2"></span>
              </h5>
            </div>
          </div>
          <div className="card mb-2 col-6" aria-hidden="true">
            <div className="card-body">
              <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
                <span className="placeholder col-2 rounded-2"></span>
                <span className="placeholder col-8 rounded-2"></span>
              </h5>
            </div>
          </div>
          <div className="card mb-2 col-6" aria-hidden="true">
            <div className="card-body">
              <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
                <span className="placeholder col-2 rounded-2"></span>
                <span className="placeholder col-8 rounded-2"></span>
              </h5>
            </div>
          </div>
          <div className="card mb-2 col-6" aria-hidden="true">
            <div className="card-body">
              <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
                <span className="placeholder col-2 rounded-2"></span>
                <span className="placeholder col-8 rounded-2"></span>
              </h5>
            </div>
          </div>
          <div className="card mb-2 col-6" aria-hidden="true">
            <div className="card-body">
              <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
                <span className="placeholder col-2 rounded-2"></span>
                <span className="placeholder col-8 rounded-2"></span>
              </h5>
            </div>
          </div>
          <div className="card mb-2 col-6" aria-hidden="true">
            <div className="card-body">
              <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
                <span className="placeholder col-2 rounded-2"></span>
                <span className="placeholder col-8 rounded-2"></span>
              </h5>
            </div>
          </div>
          <div className="card mb-2 col-6" aria-hidden="true">
            <div className="card-body">
              <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
                <span className="placeholder col-2 rounded-2"></span>
                <span className="placeholder col-8 rounded-2"></span>
              </h5>
            </div>
          </div>
          <div className="card mb-2 col-6" aria-hidden="true">
            <div className="card-body">
              <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
                <span className="placeholder col-2 rounded-2"></span>
                <span className="placeholder col-8 rounded-2"></span>
              </h5>
            </div>
          </div>
          <div className="card mb-2 col-6" aria-hidden="true">
            <div className="card-body">
              <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
                <span className="placeholder col-2 rounded-2"></span>
                <span className="placeholder col-8 rounded-2"></span>
              </h5>
            </div>
          </div>
          <div className="card mb-2 col-6" aria-hidden="true">
            <div className="card-body">
              <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
                <span className="placeholder col-2 rounded-2"></span>
                <span className="placeholder col-8 rounded-2"></span>
              </h5>
            </div>
          </div>
          <div className="card mb-2 col-6" aria-hidden="true">
            <div className="card-body">
              <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
                <span className="placeholder col-2 rounded-2"></span>
                <span className="placeholder col-8 rounded-2"></span>
              </h5>
            </div>
          </div>
          <div className="card mb-2 col-6" aria-hidden="true">
            <div className="card-body">
              <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
                <span className="placeholder col-2 rounded-2"></span>
                <span className="placeholder col-8 rounded-2"></span>
              </h5>
            </div>
          </div>
          <div className="card mb-2 col-6" aria-hidden="true">
            <div className="card-body">
              <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
                <span className="placeholder col-2 rounded-2"></span>
                <span className="placeholder col-8 rounded-2"></span>
              </h5>
            </div>
          </div>
          <div className="card mb-2 col-6" aria-hidden="true">
            <div className="card-body">
              <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
                <span className="placeholder col-2 rounded-2"></span>
                <span className="placeholder col-8 rounded-2"></span>
              </h5>
            </div>
          </div>
          <div className="card mb-2 col-6" aria-hidden="true">
            <div className="card-body">
              <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
                <span className="placeholder col-2 rounded-2"></span>
                <span className="placeholder col-8 rounded-2"></span>
              </h5>
            </div>
          </div>
        </div>
      ) : (
        fetchedClassList?.map((ele) => (
          <label
            key={ele.key}
            className="cursor-pointer position-relative col-6 p-1"
          >
            <input
              type="checkbox"
              id={ele.label}
              value={ele.key}
              checked={selectedClass[ele.key] || false}
              onChange={() => {
                handleChange(ele.key);
              }}
              className="opacity-0 position-absolute"
            />
            <Card
              className={`p-1 flex flex-col absolute border rounded-4 transition-all duration-300 ${
                selectedClass[ele.key]
                  ? "bg-primary-subtle shadow-sm"
                  : "border-gray-300"
              }`}
            >
              <Card.Body
                style={{ height: "4rem" }}
                className="d-flex justify-content-between align-items-center"
                px-1
              >
                <img src={blackboard} alt="" width={50} />
                <p
                  className={`fw-bold d-block text-left m-0 ms-1 text-gray-500 ${
                    theme === "dark"
                      ? selectedClass[ele.key]
                        ? "text-black"
                        : "text-white"
                      : ""
                  }`}
                >
                  {ele.label}
                </p>
              </Card.Body>
            </Card>
          </label>
        ))
      )}
    </div>
  );
};

export default SelectClassStudents;
